<template>
  <div class="st-header">
    <div class="st-header-content">
      <div class="st-header-left">
        <span v-if="showBackBtn" @click="back" class="st-header-back-btn">
          <span>
            <i class="el-icon-arrow-left"></i>
          </span>
          <span class="st-header-back">返回</span>
        </span>
        <span class="st-header-close st-header-close-btn" v-if="showCloseBtn" @click="close">关闭</span>
      </div>
      <div class="st-header-center">{{ title }}</div>
      <div class="st-header-right">
        <slot name="header-right">
        </slot>
				<span v-if="moreOp.length > 0" class="st-header-action-btn st-header-more-btn" @click.stop="openMoreop">
					<i class="el-icon-s-operation"></i>
				</span>
      </div>
    </div>
		<div class="page-more" v-if="showMoreOp">
			<ul>
				<li v-for="(item, i) in moreOp" :key="i" @click="command(item.val)">
					{{ item.title }}
				</li>
			</ul>
		</div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: () => {
        return '';
      }
    },
    backAble: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    closeAble: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
		close: {
			type: Function,
			default: () => {
				this.back();
			}
		},
		moreOp: {
			type: Array,
			default: () => {
				return [];
			}
		},

  },
  data() {
    return {
      showMoreOp: false,
    };
  },
  watch: {},
  computed: {
    showBackBtn() {
      return this.backAble;
    },
    showCloseBtn() {
      return this.closeAble && !this.backAble;
    }
  },

  methods: {
    init() {},
    back() {
      this.$router.go(-1);
    },
		openMoreop() {
			this.showMoreOp = true;
		},
		command(val) {
			this.$emit('command', val)
		},
  },
  created() {
    this.init();
  },
  mounted() {
  	document.addEventListener('click', () => { this.showMoreOp = false; })
  },
};
</script>

<style lang="scss" scoped>
.st-header {
  overflow: hidden;
  /* 预留安全区，避免刘海屏/企业微信容器遮挡 */
  height: calc(44px + constant(safe-area-inset-top));
  height: calc(44px + env(safe-area-inset-top));
  font-size: 14px;
  font-weight: bold;

  .st-header-content {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: white;
    box-sizing: border-box;
    padding-top: constant(safe-area-inset-top);
    padding-top: env(safe-area-inset-top);
    height: calc(44px + constant(safe-area-inset-top));
    height: calc(44px + env(safe-area-inset-top));
    display: flex;
    align-items: center;
  }

  .st-header-left,
  .st-header-center,
  .st-header-right {
    flex: 1;
    min-width: 0;
    line-height: 44px;
  }

  .st-header-left {
    display: flex;
    align-items: center;
    padding-left: 10px;
    white-space: nowrap;
    gap: 8px;

    .st-header-back-btn,
    .st-header-close-btn {
      display: inline-flex;
      align-items: center;
      height: 32px;
      line-height: 32px;
    }

    .el-icon-arrow-left {
      font-size: 20px;
      font-weight: bold;
      vertical-align: middle;
      margin-right: 2px;
    }

    .st-header-back {
      vertical-align: middle;
    }

    .st-header-close {
      margin-left: 0;
    }
  }

  .st-header-center {
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0 8px;
  }

  .st-header-right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-right: 10px;
    white-space: nowrap;
    gap: 8px;

    > * {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      height: 32px;
      line-height: 32px;
    }

    .st-header-action-btn {
      width: 32px;
      font-size: 22px;
      line-height: 1;
    }

    /* 统一右侧操作图标视觉尺寸与颜色 */
    .el-icon-circle-plus,
    .el-icon-plus,
    .el-icon-s-operation,
    .van-icon {
      font-size: 22px !important;
      color: #1a89fa;
      line-height: 1;
    }
  }
}

.page-more{
	position: fixed;
	top: calc(44px + constant(safe-area-inset-top));
	top: calc(44px + env(safe-area-inset-top));
	background-color: white;
	z-index: 9999;
	width: 100px;
	text-align: center;
	padding-top: 8px;
	right: 2px;
	border-radius: 5px;
	box-shadow: 0px 1px 3px 0px	;
	padding-bottom: 3px;
}

.page-more li {
	padding: 5px 8px;
}
.page-more li:after{
	content: '';
	display: block;
	width: 90%;
	border-bottom: 1px solid;
	margin-left: 3px;
}

.page-more:before {
		content: '';
		position: absolute;
		border-style: solid;
		border-width: 0 8px 8px 8px;
		border-color: transparent transparent #fff transparent;
		top: -8px;
		right: 12px;
		transform: translateX(-50%);
}

.page-more li:last-child:after {
	display: none;
}
</style>
<style lang="scss">
.seomain .tab-tilte {
  display: flex;
  align-items: center;
  min-height: 62px;
  padding: 2px 0 4px;
  box-sizing: border-box;
}

.seomain .tab-tilte li,
.seomain .tab-tilte .text-center {
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.seomain .tab-tilte li span,
.seomain .tab-tilte .text-center span {
  line-height: 1;
}

.seomain .tab-tilte .active span {
  padding: 10px 10px;
  border-radius: 999px;
}
</style>
